import React, {memo} from "react";
import {Checkbox, Form, Input, Select, Switch} from "antd";
import {MaskedInput} from "antd-mask-input";
import {DatePickerField} from "../newCourierStyles";
import moment from "moment";
import locale from "antd/es/date-picker/locale/tr_TR";
import {VFlex} from "components/_defaultComponents/Flex/VFlex";

export const FormInput = memo(({label, fieldKey, value, error, touched, onChange, flex = 1, required = false}) => (
    <VFlex vertical flex={flex} style={{minWidth: 0}}>
        <Form.Item
            label={label}
            required={required}
            data-testid={`${fieldKey}Input`}
            validateStatus={error && touched ? "error" : "success"}
            help={error && touched ? error : null}
        >
            <Input name={fieldKey} value={value} onChange={onChange} />
        </Form.Item>
    </VFlex>
));

FormInput.displayName = "FormInput";

export const FormSelect = memo(
    ({
        label,
        fieldKey,
        value,
        error,
        touched,
        onChange,
        data,
        mapKey = null,
        mapValue = null,
        disabled = false,
        flex = 1,
        textFromi18n = false,
        required = false,
        t
    }) => (
        <VFlex vertical flex={flex} style={{minWidth: 0}}>
            <Form.Item
                label={label}
                required={required}
                validateStatus={error && touched ? "error" : "success"}
                help={error && touched ? error : null}
            >
                <Select
                    allowClear
                    showSearch
                    name={fieldKey}
                    disabled={disabled}
                    value={value}
                    data-testid={`${fieldKey}Select`}
                    onChange={onChange}
                >
                    {data?.map(item => (
                        <Select.Option
                            key={mapKey ? item[mapKey] : item}
                            value={mapKey ? item[mapKey] : item}
                            data-testid="courierTypeSelect_option"
                        >
                            {mapValue
                                ? item[mapValue]
                                : textFromi18n
                                ? t(`fields.${item}`, {ns: "common"})
                                : item}
                        </Select.Option>
                    ))}
                </Select>
            </Form.Item>
        </VFlex>
    )
);

FormSelect.displayName = "FormSelect";

export const MaskedInputField = memo(({label, fieldKey, value, error, touched, onChange, flex = 1, required = false}) => (
    <VFlex vertical flex={flex} style={{minWidth: 0}}>
        <Form.Item
            label={label}
            required={required}
            validateStatus={error && touched ? "error" : "success"}
            help={error && touched ? error : null}
        >
            <MaskedInput
                name={fieldKey}
                placeholder="0(555)-555-5555"
                mask="1(111)-111-1111"
                value={value}
                onChange={onChange}
                data-testid={`${fieldKey}Number`}
            />
        </Form.Item>
    </VFlex>
));

MaskedInputField.displayName = "MaskedInputField";

export const TextAreaField = memo(({label, fieldKey, value, error, touched, onChange, placeholder = "", required = true}) => (
    <VFlex vertical fullWidth>
        <Form.Item
            label={label}
            validateStatus={error && touched ? "error" : "success"}
            required={required}
            help={error && touched ? error : null}
        >
            <Input.TextArea
                name={fieldKey}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                data-testid={`${fieldKey}Input`}
            />
        </Form.Item>
    </VFlex>
));

TextAreaField.displayName = "TextAreaField";

export const FormCheckbox = memo(({value, onChange, label, textKey}) => (
    <VFlex>
        <Checkbox
            checked={value}
            data-testid={`${textKey}Checkbox`}
            data-testvalue={value}
            onChange={e => onChange(e.target.checked)}
        >
            {label}
        </Checkbox>
    </VFlex>
));

FormCheckbox.displayName = "FormCheckbox";

export const FormDatePicker = memo(({label, fieldKey, value, error, touched, onChange, required = false}) => (
    <VFlex vertical flex={1} style={{minWidth: 0}}>
        <Form.Item
            label={label}
            required={required}
            validateStatus={error && touched ? "error" : "success"}
            help={error && touched ? error : null}
        >
            <DatePickerField
                locale={locale}
                value={value ? moment(value) : ""}
                name="birthDate"
                format="DD/MM/YYYY"
                data-testid={`${fieldKey}Picker`}
                onChange={onChange}
            />
        </Form.Item>
    </VFlex>
));

FormDatePicker.displayName = "FormDatePicker";

export const FormSwitch = memo(({label, fieldKey, value, onChange, flex = 1}) => (
    <VFlex vertical flex={flex} style={{minWidth: 0}}>
        <Form.Item label={label}>
            <Switch checked={value} onChange={onChange} data-testid={`${fieldKey}Switch`} />
        </Form.Item>
    </VFlex>
));

FormSwitch.displayName = "FormSwitch";
